import React, { useEffect, useState } from 'react';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import Home from './pages/Home/Home';
import AboutUs from './pages/AboutUs/AboutUs';
import Services from './pages/Services/Services';
import Projects from './pages/Projects/Projects';
import Prices from './pages/Prices/Prices';
import Topics from './pages/Topics/Topics';
import ContactUs from './pages/ContactUs/ContactUs';
import { ProjectProvider } from './context/ProjectContext';
import Nav from './components/Navbar/MobileNav';
import Loading from './components/Loading';
import Footer from './components/Footer/Footer';
import ProjectDetail from './pages/Projects/ProjectDetail';
import ImagePreviewPage from './pages/Projects/ImagePreviewPage';

// أيقونة واتساب
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const App: React.FC = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <HelmetProvider>
      <Helmet>
        <html lang="ar" />
        <title>سابورت كونستركشن - شركة تشطيب في مصر</title>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1, user-scalable=yes" />
        <meta name="theme-color" content="#000000" />
        <link rel="icon" href="%PUBLIC_URL%/favicon.ico" />
        <link rel="apple-touch-icon" href="%PUBLIC_URL%/logo192.png" />
        <link rel="manifest" href="%PUBLIC_URL%/manifest.json" />
        <link
          rel="preload"
          href="https://fonts.googleapis.com/css2?family=Cairo:wght@400;600;700&display=swap"
          as="style"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Cairo:wght@400;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Lora:ital,wght@0,400..700;1,400..700&family=Tajawal:wght@200;300;400;500;700;800;900&display=swap"
          rel="stylesheet"
        />
        {/* Google Tag Manager */}
        <script>
          {`
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-TSPM4L3T');
          `}
        </script>
        <script async src="https://www.googletagmanager.com/gtag/js?id=AW-11525595499"></script>
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'AW-11525595499');
          `}
        </script>
      </Helmet>
      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-TSPM4L3T"
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
        />
      </noscript>

      <ProjectProvider>
        <Router>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/services" element={<Services />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/project/:id" element={<ProjectDetail />} />
            <Route path="/image-preview" element={<ImagePreviewPage />} />
            <Route path="/prices" element={<Prices />} />
            <Route path="/topics" element={<Topics />} />
            <Route path="/contact-us" element={<ContactUs />} />
          </Routes>
          <Footer />
          <Nav />

          {/* زر واتساب ثابت */}
<a
  href="https://wa.me/201003234531"
  target="_blank"
  rel="noopener noreferrer"
  className="fixed bottom-20 left-4 max-sm:bottom-32 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg z-50 transition-all duration-300 animate-bounce-custom"
  aria-label="Chat on WhatsApp"
>
  <WhatsAppIcon style={{ fontSize: "2rem" }} />
</a>

        </Router>
      </ProjectProvider>
    </HelmetProvider>
  );
};

export default App;
